export const railwayURL = {
  development: 'http://localhost:3004',
  preview: 'https://pump-router.bshb.dev',
  production: 'https://pump-router.basehub.com',
}
